<template>
    <div>
        <!-- Add New Location Button -->
        <el-row>
            <el-col :span="24">
                <!-- Button: open the Setting modal -->
                <el-button type="primary" icon="el-icon-plus" @click="handleOpenSettingModal">Add User</el-button>
                <!-- Setting Modal -->
                <el-dialog
                        :title="settingModalTitle"
                        :visible.sync="showSettingModal"
                        top="10vh"
                        @closed="handleClosedSettingModal"
                >
                    <schedule-monitor-setting-form :show-sub-user="true"></schedule-monitor-setting-form>
                </el-dialog>
            </el-col>
        </el-row>
        <br/>
        <!-- Places Table -->
        <el-row>
            <el-col :span="24">
                <el-table
                        style="width: 100%"
                        v-loading="isLoadingUsers"
                        :data="users"
                        border
                >
                    <el-table-column
                            prop="name"
                            label="Name"
                            min-width="20%"
                    ></el-table-column>
                    <el-table-column
                            prop="mobile_number"
                            label="Mobile"
                            min-width="30%"
                    ></el-table-column>
                    <el-table-column
                            prop="email"
                            label="Email"
                            min-width="30%"
                    ></el-table-column>
                    <el-table-column
                            label="Action"
                            align="center"
                            min-width="20%"
                    >
                        <template slot-scope="scope">
                            <el-button size="mini" type="text">Init Settings</el-button>
                            <el-button size="mini" type="text">Edit</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data () {
            return {
                showSettingModal: false,
            }
        },
        methods: {
            handleOpenSettingModal() {
                this.showSettingModal = true;
            },
            handleClosedSettingModal() {
                console.log('modal closed');
            },
        },
        mounted() {
            this.$store.dispatch('loadUsers');
        },
        computed: {
            users: function () {
                return this.$store.getters.getUsers;
            },
            isLoadingUsers: function () {
                return this.$store.getters.getUsersLoadStatus === 1;
            },
            settingModalTitle: function () {
                return 'Setting';
            }
        }
    }
</script>

<style scoped>
    >>> svg {
        vertical-align: unset;
    }
</style>